import React from "react";
import PropTypes from 'prop-types';

import styles from '@/views/components/Tab/Tab.module.scss';

const Tab = ({ isBtn, isOnlyTab, disabled, isTabActive, onClickHandler, value, label, style }) => {
	return (
		!isOnlyTab ? (
			<div
				className={ `${styles['tab']}
								${isBtn ? ' btn' : ''}
								${isTabActive ? ' active' : ''}
								${disabled ? ' disabled' : ''}` }
				style={ style }
				onClick={ () => onClickHandler(value) }
			>
				{label}
			</div>
		) : (
			<div
				className={ styles['tab'] }
			>
				{label}
			</div>
		)

	);
};

Tab.propTypes = {
	isBtn: PropTypes.bool,
	isOnlyTab: PropTypes.bool,
	disabled: PropTypes.bool,
	isTabActive: PropTypes.bool,
	onClickHandler: PropTypes.func,
	value: PropTypes.any,
	label: PropTypes.string,
};

export default Tab;